import React from "react";
import { Card, CardBody, Col, Row, Badge } from "reactstrap";

const FinansIstatistikleri = ({ stats, user }) => {
  return (
    <Card className="shadow-sm border-0 h-100">
      <CardBody className="bg-primary-subtle rounded-top">
        <div className="d-flex">
          <div className="me-4">
            <i className="mdi mdi-shield-account text-primary h1" />
          </div>
          <div className="flex-grow-1">
            <div className="text-primary">
              <h5 className="text-primary fw-bold">{user?.Users_NameSurname || "Yönetici"}</h5>
              <p className="mb-1">{user?.Users_Email}</p>
              <Badge color="primary">LojGo Sistem Yöneticisi</Badge>
            </div>
          </div>
        </div>
      </CardBody>
      
      <CardBody className="border-top">
        <Row>
          <Col sm="6">
            <div>
              <p className="text-muted mb-2 fw-semibold">Sistemdeki İşlem Hacmi</p>
              <h5 className="text-success fw-bold">{stats.totalRevenue.toLocaleString('tr-TR')} TL</h5>
            </div>
          </Col>
          <Col sm="6">
            <div className="text-sm-end mt-4 mt-sm-0">
              <p className="text-muted mb-2 fw-semibold">Aylık Büyüme</p>
              <h5 className="fw-bold">
                + %12
                <Badge color="success" className="ms-2 align-bottom"><i className="mdi mdi-arrow-up"></i> Yükseliş</Badge>
              </h5>
            </div>
          </Col>
        </Row>
      </CardBody>
      
      <CardBody className="border-top">
        <p className="text-muted mb-4 fw-semibold">Hızlı Finansal Kısayollar</p>
        <div className="text-center">
          <Row>
            <Col sm="4">
              <div style={{ cursor: "pointer" }} className="p-2 hover-effect">
                <div className="font-size-24 text-success mb-2"><i className="bx bx-send" /></div>
                <p className="text-muted mb-0" style={{fontSize:"12px"}}>Taşıyıcıya Öde</p>
              </div>
            </Col>
            <Col sm="4">
              <div style={{ cursor: "pointer" }} className="p-2 hover-effect">
                <div className="font-size-24 text-primary mb-2"><i className="bx bx-import" /></div>
                <p className="text-muted mb-0" style={{fontSize:"12px"}}>Tahsilat Yap</p>
              </div>
            </Col>
            <Col sm="4">
              <div style={{ cursor: "pointer" }} className="p-2 hover-effect">
                <div className="font-size-24 text-warning mb-2"><i className="bx bx-file" /></div>
                <p className="text-muted mb-0" style={{fontSize:"12px"}}>Faturalar</p>
              </div>
            </Col>
          </Row>
        </div>
      </CardBody>
    </Card>
  );
};

export default FinansIstatistikleri;